module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst fieldConfig           = model.config || {}\nconst managementConfig      = fieldConfig.managementConfig || {}\nconst buttonNeutral         = fieldConfig.style === 'neutral'\nconst single                = managementConfig.multiSelect === false || managementConfig.maxNrOfElements == 1\nconst additionalClasses = []\nif(model.fullScreen)            additionalClasses.push('fullScreen');\nif(model.isDirty)               additionalClasses.push('isDirty');\nif(fieldConfig.slim)            additionalClasses.push('slim');\nif(single)                      additionalClasses.push('single');\nif(fieldConfig.style)           additionalClasses.push(fieldConfig.style);\nconst nrOfImages    = utils.collectionSize(model.dataJSON)\nconst preventImages = fieldConfig.showImages === false && !model.fullScreen\nlet fullScreenButtonType = 'fullScreen'\nif(model.fullScreen){\nfullScreenButtonType = 'closeFullScreen'\n}\nconst controls = {\nassign:             !preventImages,\nassignFiltered:     !preventImages && !fieldConfig.slim && !fieldConfig.instantUpload,\nrenew:              !preventImages && model.extendedButtonActionsGranted,\ndelete:             !preventImages,\nfullScreen:         !fieldConfig.slim,\n// single slim assignment controls\nopen:               !preventImages && single && fieldConfig.slim && nrOfImages > 0,\ncopyToClipboardUrl: !preventImages && single && fieldConfig.slim && !fieldConfig.slimControls && nrOfImages > 0,\nassignTags:         !preventImages && single && fieldConfig.slim && !fieldConfig.slimControls && nrOfImages > 0,\nedit:               !preventImages && single && fieldConfig.slim && !fieldConfig.slimControls && nrOfImages > 0,\npause:              !preventImages && single && fieldConfig.slim && !fieldConfig.slimControls && nrOfImages > 0,\n}\n%><div data-field-code=\"<%- model.fieldCode || '' %>\" class=\"<%= additionalClasses.join(' '); %>\"><%\nif(fieldConfig.showInlineInformation && model.information){\n%><p class=\"information labelLike\"><%- model.information %></p><%\n}\n%><div class=\"controls\"><%\nif(controls.assign){\nconst buttonFormMapping = formMapping\nbuttonFormMapping.neutral = buttonNeutral\n%><%- include('./image-button', { formMapping: buttonFormMapping, model: model, config: config }); %><%\n}\nif(controls.assignFiltered){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'filter', context: 'media-image', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }); %><%\n}\nif(controls.renew){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'renew', context: 'media-image', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }); %><%\n}\nif(controls.delete){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'media-image', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }); %><%\n}\nif(controls.fullScreen){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: fullScreenButtonType, context: 'media-image', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }); %><%\n}\n// single slim assignment controls\nif(controls.open){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'open', context: 'media-image', mode: 'assignment', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }); %><%\n}\nif(controls.copyToClipboardUrl){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'copyToClipboardUrl', context: 'media-image', mode: 'assignment', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }); %><%\n}\nif(controls.assignTags){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'showAssign', context: 'tags', mode: 'assignment', symbolOnly: !model.fullScreen, neutral: buttonNeutral, icon: 'fi fi-mediaImageDetails' } }); %><%\n}\nif(controls.edit){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: 'media-image', mode: 'assignment', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }); %><%\n}\nif(controls.pause){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'pause', context: 'media-image', mode: 'assignment', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }); %><%\n}\n%></div><%\nif(!fieldConfig.slim){\n%><div class=\"notices\"><%\n%><div class=\"notice dirty\"><%= storage.__('hint.imageField.dirty') %></div><%\nif(nrOfImages <= 0) {\n%><div class=\"notice\"><%= storage.__('hint.imageField.empty') %></div><%\n} else if(preventImages) {\n%><div class=\"notice\"><%= storage.__('hint.imageField.hiddenImages', { nrOfElements: nrOfImages }) %></div><%\n}\n%></div><%\n}\n%><div class=\"mediaContainer\"><%\n%><div class=\"media\"><%\nif(!preventImages){\nif(nrOfImages > 0) {\nfor(const image of Object.values(model.dataJSON || {})){\n%><%- include('../media/image/image', { resourceData: image, config: { context: 'assignment', slimControls: fieldConfig.slimControls }, model: { extendedButtonActionsGranted: model.extendedButtonActionsGranted } }); %><%\n}\n} else if(fieldConfig.slim) {\n%><%- include('../media/image/image', { resourceData: {}, config: { context: 'assignment' }, model: { extendedButtonActionsGranted: model.extendedButtonActionsGranted } }); %><%\n}\n}\n%></div><%\n%></div><%\n%></div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\fields\\image.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const fieldConfig           = model.config || {}
const managementConfig      = fieldConfig.managementConfig || {}
const buttonNeutral         = fieldConfig.style === 'neutral'
const single                = managementConfig.multiSelect === false || managementConfig.maxNrOfElements == 1
const additionalClasses = []
if(model.fullScreen)            additionalClasses.push('fullScreen');
if(model.isDirty)               additionalClasses.push('isDirty');
if(fieldConfig.slim)            additionalClasses.push('slim');
if(single)                      additionalClasses.push('single');
if(fieldConfig.style)           additionalClasses.push(fieldConfig.style);
const nrOfImages    = utils.collectionSize(model.dataJSON)
const preventImages = fieldConfig.showImages === false && !model.fullScreen
let fullScreenButtonType = 'fullScreen'
if(model.fullScreen){
fullScreenButtonType = 'closeFullScreen'
}
const controls = {
assign:             !preventImages,
assignFiltered:     !preventImages && !fieldConfig.slim && !fieldConfig.instantUpload,
renew:              !preventImages && model.extendedButtonActionsGranted,
delete:             !preventImages,
fullScreen:         !fieldConfig.slim,
// single slim assignment controls
open:               !preventImages && single && fieldConfig.slim && nrOfImages > 0,
copyToClipboardUrl: !preventImages && single && fieldConfig.slim && !fieldConfig.slimControls && nrOfImages > 0,
assignTags:         !preventImages && single && fieldConfig.slim && !fieldConfig.slimControls && nrOfImages > 0,
edit:               !preventImages && single && fieldConfig.slim && !fieldConfig.slimControls && nrOfImages > 0,
pause:              !preventImages && single && fieldConfig.slim && !fieldConfig.slimControls && nrOfImages > 0,
}

    ; __line = 31
    ; __append("<div data-field-code=\"")
    ; __append( model.fieldCode || '' )
    ; __append("\" class=\"")
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">")
    ; 
if(fieldConfig.showInlineInformation && model.information){

    ; __line = 33
    ; __append("<p class=\"information labelLike\">")
    ; __append( model.information )
    ; __append("</p>")
    ; 
}

    ; __line = 35
    ; __append("<div class=\"controls\">")
    ; 
if(controls.assign){
const buttonFormMapping = formMapping
buttonFormMapping.neutral = buttonNeutral

    ; __line = 39
    ; __append( include('./image-button', { formMapping: buttonFormMapping, model: model, config: config }) )
    ; 
}
if(controls.assignFiltered){

    ; __line = 42
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'filter', context: 'media-image', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }) )
    ; 
}
if(controls.renew){

    ; __line = 45
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'renew', context: 'media-image', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }) )
    ; 
}
if(controls.delete){

    ; __line = 48
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'media-image', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }) )
    ; 
}
if(controls.fullScreen){

    ; __line = 51
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: fullScreenButtonType, context: 'media-image', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }) )
    ; 
}
// single slim assignment controls
if(controls.open){

    ; __line = 55
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'open', context: 'media-image', mode: 'assignment', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }) )
    ; 
}
if(controls.copyToClipboardUrl){

    ; __line = 58
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'copyToClipboardUrl', context: 'media-image', mode: 'assignment', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }) )
    ; 
}
if(controls.assignTags){

    ; __line = 61
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'showAssign', context: 'tags', mode: 'assignment', symbolOnly: !model.fullScreen, neutral: buttonNeutral, icon: 'fi fi-mediaImageDetails' } }) )
    ; 
}
if(controls.edit){

    ; __line = 64
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: 'media-image', mode: 'assignment', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }) )
    ; 
}
if(controls.pause){

    ; __line = 67
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'pause', context: 'media-image', mode: 'assignment', symbolOnly: !model.fullScreen, neutral: buttonNeutral } }) )
    ; 
}

    ; __line = 69
    ; __append("</div>")
    ; 
if(!fieldConfig.slim){

    ; __line = 71
    ; __append("<div class=\"notices\">")
    ; 

    ; __line = 72
    ; __append("<div class=\"notice dirty\">")
    ; __append(escapeFn( storage.__('hint.imageField.dirty') ))
    ; __append("</div>")
    ; 
if(nrOfImages <= 0) {

    ; __line = 74
    ; __append("<div class=\"notice\">")
    ; __append(escapeFn( storage.__('hint.imageField.empty') ))
    ; __append("</div>")
    ; 
} else if(preventImages) {

    ; __line = 76
    ; __append("<div class=\"notice\">")
    ; __append(escapeFn( storage.__('hint.imageField.hiddenImages', { nrOfElements: nrOfImages }) ))
    ; __append("</div>")
    ; 
}

    ; __line = 78
    ; __append("</div>")
    ; 
}

    ; __line = 80
    ; __append("<div class=\"mediaContainer\">")
    ; 

    ; __line = 81
    ; __append("<div class=\"media\">")
    ; 
if(!preventImages){
if(nrOfImages > 0) {
for(const image of Object.values(model.dataJSON || {})){

    ; __line = 85
    ; __append( include('../media/image/image', { resourceData: image, config: { context: 'assignment', slimControls: fieldConfig.slimControls }, model: { extendedButtonActionsGranted: model.extendedButtonActionsGranted } }) )
    ; 
}
} else if(fieldConfig.slim) {

    ; __line = 88
    ; __append( include('../media/image/image', { resourceData: {}, config: { context: 'assignment' }, model: { extendedButtonActionsGranted: model.extendedButtonActionsGranted } }) )
    ; 
}
}

    ; __line = 91
    ; __append("</div>")
    ; 

    ; __line = 92
    ; __append("</div>")
    ; 

    ; __line = 93
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\fields\image.ejs

}